/**
 * Stable CSS class names for E2E — SummaryV2 page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `summary-v2__<element>`; inputs and user-interactable
 * controls use `summary-v2-input--<name>`.
 */
export const SV = {
    page: 'summary-v2-page',
    root: 'summary-v2',

    breadcrumb: 'summary-v2__breadcrumb',
    loading: 'summary-v2__loading',

    list: 'summary-v2__list',
    listSearchBar: 'summary-v2__list-search-bar',
    listSearchLabel: 'summary-v2__list-search-label',
    listDateRanger: 'summary-v2__list-date-ranger',
    dateRange: 'summary-v2-input--date-range',
    btnSearch: 'summary-v2-input--button-search',

    listGridContainer: 'summary-v2__list-grid-container',
    listGrid: 'summary-v2__list-grid',
    listNoRecord: 'summary-v2__list-no-record',

    btnEdit: 'summary-v2-input--button-edit',
    btnAxapta: 'summary-v2-input--button-axapta',

    statusChip: 'summary-v2__status-chip',
    /** Append modifier; e.g. `summary-v2__status-chip--accounting-complete`. */
    statusChipAccountingComplete: 'summary-v2__status-chip--accounting-complete',
    statusChipNeedRecalculate: 'summary-v2__status-chip--need-recalculate',
    statusChipPendingAccounting: 'summary-v2__status-chip--pending-accounting',
    statusChipTransferComplete: 'summary-v2__status-chip--transfer-complete',

    detail: 'summary-v2__detail',
    detailLoading: 'summary-v2__detail-loading',
    detailBackBar: 'summary-v2__detail-back-bar',
    btnBack: 'summary-v2-input--button-back',
    detailBody: 'summary-v2__detail-body',
    detailCard: 'summary-v2__detail-card',
    detailHeader: 'summary-v2__detail-header',
    detailHeaderLabel: 'summary-v2__detail-header-label',
    detailHeaderValue: 'summary-v2__detail-header-value',

    receipt: 'summary-v2__receipt',
    receiptActions: 'summary-v2__receipt-actions',
    btnEditSave: 'summary-v2-input--button-edit-save',
    btnReceiptStatus: 'summary-v2-input--button-receipt-status',
    btnReceiptTransfer: 'summary-v2-input--button-receipt-transfer',

    receiptItem: 'summary-v2__receipt-item',
    receiptItemTitleBox: 'summary-v2__receipt-item-title-box',
    receiptItemTitle: 'summary-v2__receipt-item-title',
    receiptItemAmountBox: 'summary-v2__receipt-item-amount-box',
    receiptItemAmount: 'summary-v2__receipt-item-amount',
    receiptItemAmountInput: 'summary-v2-input--receipt-item-amount',
} as const;

export const svCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
